import { Injectable } from "@angular/core";

import { Observable, of } from "rxjs";
import { FLOW_BUILDER_HOME_ROUTE, FlowStateService } from "src/app/main/core/flow-management/services/flow-state.service";

@Injectable({
    providedIn: "root",
})
export class FlowSetupResolver {
    constructor(private flowStateService: FlowStateService) {}

    resolve(): Observable<boolean> {
        this.flowStateService.setFlowBuilderMode({
            type: "bot/onboarding",
            sourceRoute: FLOW_BUILDER_HOME_ROUTE,
        });

        return of(true);
    }
}
